import validate from "/usr/src/app/content/n3-treatments-b0d64776-4c0a-42ad-afad-16b2dcfdc648/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-b0d64776-4c0a-42ad-afad-16b2dcfdc648/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}